import cloneDeep from "lodash/cloneDeep";

import { api } from "../libs/apiLib";

const Utility = {
	getConfig: async function () {
		return await api.get(`${process.env.REACT_APP_API_BASE_URL}v1/utility/config`).then((res) => {
			return Utility.toModel(res.data);
		});
	},
	toModel: function (data) {
		if (!data) return null;

		let model = cloneDeep(data);
		return model;
	},
};

export default Utility;
